import { debounce } from '../utils';

const setPanelsHeight = ($tabGroup) => {
    const $panels = $tabGroup.find('.tab-panels');
    const $panel = $tabGroup.find('.tab-panel');
    $panel.css('height', 'auto');
    const panelHeights = (
        $panels
            .children()
            .map((index, el) => $(el).height())
            .get()
    );
    const maxHeight = Math.max(...panelHeights)
    $panels.height(maxHeight);
    $panel.css('height', '100%');
};

const managePanelsHeight = ($tabGroup) => {
    setPanelsHeight($tabGroup);
    $(window).resize(
        debounce(
            () => setPanelsHeight($tabGroup),
            100
        )
    );
};

const prepareTabControls = ($tabGroup) => {
    $tabGroup.find('.tab').click(function(event) {
        event.preventDefault();
        if ($(this).hasClass('active')) return;
        const currentIndex = $('.tab.active').index();
        const index = $(this).index();
        $('.tab.active').removeClass('active');
        $('.tab-panel').eq(currentIndex).removeClass('active');
        $('.tab').eq(index).addClass('active');
        $('.tab-panel').eq(index).addClass('active');
    });
};

const initialize = () => {
    $('.tab-group').each(function() {
        managePanelsHeight($(this));
        prepareTabControls($(this));
    });
};

export default {
    initialize,
};

